import { render, staticRenderFns } from "./Input_list.vue?vue&type=template&id=87bbbe14&scoped=true&"
import script from "./Input_list.vue?vue&type=script&lang=js&"
export * from "./Input_list.vue?vue&type=script&lang=js&"
import style0 from "./Input_list.vue?vue&type=style&index=0&id=87bbbe14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87bbbe14",
  null
  
)

export default component.exports